export enum DownloadFileType {
    Audio = "audio",
    Document = "document",
    AfnamePapier = "afname-pap",
    AfnameDigitaal = "afname-dig",
    Default = "default",
}